/* eslint react/jsx-props-no-spreading: 0 */
/* eslint arrow-body-style: 0 */
/* eslint react/prop-types: 0 */

// Custom Link component that handles internal and external 'to' props
// Modified from:
// https://www.gatsbyjs.org/docs/gatsby-link/#reminder-use-link-only-for-internal-links
//
import { Link as GatsbyLink } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import { isLinkInternal, parseInternalLink } from '@utils/navigationHelpers';

const Link = ({
  ariaLabel, partiallyActive, activeClassName, className, children, to, newTab = null,
}) => {
  const ariaProps = (ariaLabel !== '') ? { 'aria-label': ariaLabel } : {};

  if (newTab) {
    return (
      <a
        {...ariaProps}
        className={className}
        href={to}
        target="_blank"
        rel="noreferrer"
      >
        { children }
      </a>
    );
  }

  if (isLinkInternal(to)) {
    return (
      <GatsbyLink
        activeClassName={activeClassName}
        {...ariaProps}
        className={className}
        partiallyActive={partiallyActive}
        to={parseInternalLink(to)}
      >
        {children}
      </GatsbyLink>
    );
  }

  const checkBlankOrSelf = (link) => {
    if (newTab !== null) {
      return newTab === false ? '_self' : '_blank';
    }
    return (link
      && (link.split('/')[2] === 'www.smm.org'
        || link.split('/')[2] === 'my.smm.org'
        || link.split('/')[2] === 'store.smm.org'
        || link.split('/')[2] === 'smm.planningyourlegacy.org')) ? '_self' : '_blank';
  };

  return (
    <a
      {...ariaProps}
      className={className}
      href={to}
      target={checkBlankOrSelf(to)}
      rel="noreferrer"
    >
      {children}
    </a>
  );
};

Link.defaultProps = {
  activeClassName: '',
  ariaLabel: '',
  children: null,
  className: '',
  partiallyActive: false,
};

Link.propTypes = {
  activeClassName: PropTypes.string,
  ariaLabel: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  className: PropTypes.string,
  partiallyActive: PropTypes.bool,
  to: PropTypes.string.isRequired,
};

export default Link;
